var exports = {
  "k": "xe533113f--d5abe9--container",
  "K": "xe533113f--d5abe9--icon",
};

module.exports = exports;
